import React, { useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  InputGroup,
  Row,
  Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { ALERTUS_USER_GUIDE_URL, routes } from "../../../common/constants";
import { SearchIcon } from "../../../components/ui/icons";
import "./alertus.scss";
import TableView from "../../../components/tableView";
import AlertusColumns from "./alertusColumns";
import CreateAlertusTokenModal from "../../../components/createAlertusTokenModal";
import useAlertusTable from "./useAlertusTable";
import useAlertus from "./useAlertus";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import CopyInputField from "../singlewire/copyInputField";

function Alertus() {
  const dispatch = useDispatch<RootState>();
  const alertusColumns = AlertusColumns();
  const {
    rows,
    globalFilter,
    setGlobalFilter,
    noDataMessage,
    text,
    copied,
    setCopied,
  } = useAlertus();

  const { handleSearchSubmit, searchTerm, handleSearchChange } =
    useAlertusTable();

  return (
    <div className="integration-container">
      <div className="integration-header">
        <div className="integration-header-content">
          <div className="integration-heading">3rd Party Integration</div>
          <a
            href={ALERTUS_USER_GUIDE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Alertus Integration Guide
          </a>
        </div>
        <Row>
          <Col sm={6}>
            <div className="integration-breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item
                  linkAs={Link}
                  linkProps={{ to: `${routes.integrations}` }}
                >
                  3rd Party Integration
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Alertus Configuration</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>
          <Col sm={2}></Col>
          <Col sm={4}>
            <div className="dm-search-input">
              <Form onSubmit={(e) => handleSearchSubmit(e, setGlobalFilter)}>
                <InputGroup>
                  <Form.Control
                    placeholder="Search by Token Name"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <Button
                    id="search-tree-list"
                    onClick={(e) => handleSearchSubmit(e, setGlobalFilter)}
                  >
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
      <div className="integration-webhook-url">
        <Row>
          <Col sm={2} className="label">
            <h5>Webhook URL:</h5>
          </Col>
          <Col sm={5}>
            <CopyInputField text={text} copied={copied} setCopied={setCopied} />
          </Col>
        </Row>
      </div>
      <div className="integration-body">
        <Row>
          <Col sm={2} className="label">
            <h5>Tokens</h5>
          </Col>
          <Col sm={7}></Col>
          <Col sm={3}>
            <div className="integration-config-btn">
              <CreateAlertusTokenModal />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="dm-table-container">
              <TableView
                data={rows}
                columns={alertusColumns}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                noDataMessage={noDataMessage}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Alertus;
